import type { PurchasesPackage } from "@revenuecat/purchases-capacitor";

/**
 * Discount of the yearly package vs paying the monthly price for 12 months.
 * Returns the rounded percent, or null if either package is missing or the
 * yearly is not actually cheaper than 12× monthly.
 */
export const computeYearlyDiscountPercent = (
  monthlyPackage: PurchasesPackage | undefined,
  yearlyPackage: PurchasesPackage | undefined,
): number | null => {
  const monthlyPrice = monthlyPackage?.product.price;
  const yearlyPrice = yearlyPackage?.product.price;
  if (typeof monthlyPrice !== "number" || typeof yearlyPrice !== "number") return null;
  if (monthlyPrice <= 0) return null;

  const monthlyEquivalent = monthlyPrice * 12;
  if (yearlyPrice >= monthlyEquivalent) return null;

  return Math.round((1 - yearlyPrice / monthlyEquivalent) * 100);
};
